import gql from 'graphql-tag'

export default gql`
  fragment setTableNameFragment on Preference {
    _id
    websiteId
    tableName
  }
`
